"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
function default_1() {
    const visible = (0, detect_utils_1.useVisibilityChange)({ useOnce: true });
    const targetParamRef = (0, react_1.useRef)((0, functions_1.getSearchParam)('target'));
    (0, react_1.useEffect)(() => {
        if (visible && targetParamRef.current === 'refund') {
            (0, functions_1.scrollIntoCenterView)('room_view_refund');
        }
    }, [visible]);
    const refundRef = (0, react_1.useRef)(null);
    const refundPolicy = (0, react_redux_1.useSelector)((state) => state.roomData.refund_policy);
    // ? isPreview for bottomHeight difference
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "room_view_refund", className: "surface-white", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '14px',
            padding: '20px 16px',
            marginBottom: '10px',
        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 gray-80" }, { children: t('작가님의 교환/환불 정책') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '4px', padding: '10px 0' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle5 gray-80" }, { children: t('문의 방법') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-60" }, { children: t('작가님의 문의 채널 또는 작품 문의로 메시지 남겨주세요!') }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: refundRef, css: { overflow: 'hidden' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body2 gray-60 surface-table-row", css: { padding: '16px 14px', borderRadius: '8px', wordBreak: 'break-all' } }, { children: (0, html_react_parser_1.default)((0, string_utils_1.newLineCharsToBr)(refundPolicy)) })), (0, jsx_runtime_1.jsx)(components_1.ShowMoreButton, { elementRef: refundRef, dependency: refundPolicy, bottomElementId: isPreview ? '' : 'cart_order_div' })] }))] })));
}
exports.default = default_1;
